import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  state: {
    perform: {
      id: '',
      title: '',
      picture: '',
      start: '',
      end: '',
      priceRange: '',
      location: '',
      locationName: '',
      cast: [{
        name: '',
        title: '',
        portrait: ''
      }],
      tips: [{
        color: '',
        displayName: ''
      }],
      redirect_url: '',
      description: '',
      groupedSessions: [],
      sessions: [{
        id: '',
        datetime: 1520316509366,
        status: 1,
        limit: 6,
        autoBook: 0,
        prices: [{
          id: '',
          currencyUnit: '',
          amount: '',
          status: 1,
          count: 10
        }]
      }]
    },
    showGroupedSession: 0,
    currentGroup: {id: ''},
    currentPriceList: [],
    currentPrice: '',
    currentSessions: {
      id: '',
      datetime: '',
      status: 0,
      limit: 0,
      autoBook: 0,
      prices: [
        {
          id: '',
          currencyUnit: '',
          amount: '',
          status: 0,
          count: 0
        }
      ]
    },
    currentActor: {
      picture: '',
      name: '',
      title: '',
      description: '',
      relatedDrama: [
        {
          poster: '',
          name: '',
          title: ''
        }
      ]
    },
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/theatreabove/index.js